//export const baseurl = "https://vm-colbweb2d/fastlink/";
export const baseurl = "/fastlink/";

export const getenrollmentlist = "api/private/enrollmentList";

export const checkDuplicateSsn = "api/private/checkDuplicateSsn";

export const getbenifitlist = "api/private/benefitTypes";

export const getLoggedInUserDetails = "api/private/getUsersCarefacility";

//export const mytoken ="eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjJGOVpnSnRZLWVSUEtMRVh1cWxDeSJ9.eyJpc3MiOiJodHRwczovL2Zhc3RsaW5rLWRldi51cy5hdXRoMC5jb20vIiwic3ViIjoiVTkzQTkxdWJEdFY1aXhtOEJ2TDBEUm05UDdwbzBORUFAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vZmFzdGxpbmstYXBpLmNvbS8iLCJpYXQiOjE3MTQ5NzQ2NTUsImV4cCI6MTcxNTA2MTA1NSwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIiwiYXpwIjoiVTkzQTkxdWJEdFY1aXhtOEJ2TDBEUm05UDdwbzBORUEifQ.rxI-aleMqMLICDYYwortgZEzy46RHnm-O6twA1lPAuEfy5Zx8n2e4uzYy-sHR9zDwuJmK5EOL2fuQYx4MqjWd2U7w1zdabavy_8y4XOhCJyjL8FMg5u2YWPwFRm4fwsutzvr1E7KYN9doG-fcsd82bFXQs5T25oPZ0Vm1OuoW5SArN1Ua82cbPRo5I-facwiru-1Mge_2C-4_6LkgEuDigD7b6oERC1bXCgcKMqqQii1pIgUWPuRjFDxR-RXZFynBRRVGDjEJNcZrfmcO-SZ0NeVNNpg49m1xEZQjwiRbKUEhfIfiGQ0YYgO7NOQBpUd9Gh0HQFFUiGVJoT0tjIc6g";

export const getenrollmentresident = "api/private/enrollResident";

export const createresidentStatus = "api/private/createResidentStatus";
export const deleteresidentStatus = "api/private/deleteResidentStatus";
export const getresidentStatusUserSearch ="api/private/residentStatusUserSearch";
export const getresidentStatusList = "api/private/residentStatusList";

export const getEnrollmentList = "api/private/enrollmentList?userName=";
export const getAllowanceUserOnSearch = "api/private/allowanceUserSearch";
export const createAllowanceUpdate = "api/private/createAllowanceUpdate";
export const getAllowanceListings = "api/private/allowanceUpdateList";
export const exportToExcelDirectDepositListings =
  "api/private/userEnrollmentReport?userName=";
export const token = "eyJ";
export const mytoken =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjJGOVpnSnRZLWVSUEtMRVh1cWxDeSJ9.eyJpc3MiOiJodHRwczovL2Zhc3RsaW5rLWRldi51cy5hdXRoMC5jb20vIiwic3ViIjoiVTkzQTkxdWJEdFY1aXhtOEJ2TDBEUm05UDdwbzBORUFAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vZmFzdGxpbmstYXBpLmNvbS8iLCJpYXQiOjE3MTY0NTYzMTgsImV4cCI6MTcxNjU0MjcxOCwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIiwiYXpwIjoiVTkzQTkxdWJEdFY1aXhtOEJ2TDBEUm05UDdwbzBORUEifQ.bz6R8DY2BtJ7KbXzpKRDL_SxdIvkg3i4wJZvdht2EoibMh3X9Kv1KnbS_TELEEvljBky9bWkYhnxByTPdSZzj8_X6jk-hsqFytc3jM4whHhoYoPbjUj2wpg6bv-FbWJsn14gqQpt9QAttxIiP-WhDPpGHYEpOdKJFwWeIT-i4eYj7oV5RaGPm2VyZmlFv6zV1UjehMIORWsUs11DJYGyw3H2l3qbvt4odyDJcakk6OnMAQQTcb47Jf-y45RtZHZeKIpTmeVPNgZfvRLi_CXCv9W27ZPc2Nj_S-m9Pso8KV1zdH3VamYJ0sCQPVjpUL7HYD_EdYWv_SPFhc6rhcrefQ";

//Reports
export const getAchReportList = "api/private/achReportList";
export const getEnrollmentLogDetails = "api/private/enrollmentLogDetails";

//Audit Reports
export const getAclAuditRecords = "api/admin/private/AccessLogDetails";
export const createUserAudit = "api/private/createUserAudit";
export const createAdminAudit = "api/admin/private/createAdminAudit";
export const getUserAuditRecords = "api/admin/private/userAdminAuditList";
export const getCareFacilityLogs = "api/admin/private/careFacilityLogDetails";
export const getClientUserLogs = "api/admin/private/clientUserLogDetails";
export const getAllowanceUpdateList = "api/admin/private/AllowanceUpdateList";
export const getResidentStatusUpdateList = "api/admin/private/ResidentStatusList";
export const downloadAllowanceUpdateList = "api/admin/private/downloadAllowanceUpdateList";
export const downloadResidentStatusList = "api/admin/private/downloadResidentStatusList";
/* Admin APIs*/

//ACL
export const storeUserRoleInDb = "api/admin/private/insertUserRole";
export const updateUserRole = "api/admin/private/updateUserRole";
export const getUsersRoles = "api/admin/private/getAllUserRoles";
export const getRoleOfInternalUser = "api/admin/private/getInternalUserRole";
export const getRoleOfExternalUser = "api/private/getExternalUserRole";

export const getCareFacilityList = "api/admin/private/careFacilityList";
//export const getClientUsersList =
//  "api/admin/private/clientUserList?careFacilityId=";
  export const getClientUsersList =
  "api/admin/private/clientUserList";
export const createCareFacility = "api/admin/private/createCareFacility";
export const deleteCareFacility =
  "api/admin/private/updateCareFacilityIsActive";
//export const getManagementAccessToken =
//"api/admin/private/getManagementAccessToken";
export const createClientUser = "api/admin/private/createClientUser";
export const deleteClientUser = "api/admin/private/deleteClientUser";
export const updateClientUserStatus = "api/admin/private/updateClientUser";
export const updateClientUser = "api/admin/private/updateClientUser";
export const clientUserListReport = "api/admin/private/clientUserListReport";
export const handleResendEmailForPwdReset = "api/admin/private/clientUserResendEmailVerificationLink";
export const getAchFileJobs = "api/admin/private/getAchFileJobs";
export const createAchFile = "api/admin/private/createACHFile";
export const achFileContentDownload = "api/admin/private/achFileDownload";
export const getachFileContent = "api/admin/private/getAchFileContent";
export const getBillingReportsData = "api/admin/private/getBillingFiles";
export const getBillingFileData = "api/admin/private/getBillingFileContent";
export const updateCareFacilityAsDefault = "api/private/updateDefaultCareFacilityId";
/* CONSTANTS */
export const userAudienceAPI = "https://fastlink-api.com/";
export const adminConnectionName = "okta-websterbankint-preview";
